import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InViewDirective } from './directives/in-view.directive';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { ProgressiveImageDirective } from './directives/progressive-image.directive';
import { FadeInImageDirective } from './directives/fade-in-image.directive';
import { VideoModalContainerComponent } from './shared/video-modal-container/video-modal-container.component';
import { GoogleSigninDirective } from './directives/google-signin.directive';
import { RequestComponent } from './shared/request/request.component';
import { EditorRequestComponent } from './shared/editor-request/editor-request.component';
import { TermsConditionsComponent } from './shared/terms-conditions/terms-conditions.component';

@NgModule({
  declarations: [
    InViewDirective,
    ScrollToDirective,
    ProgressiveImageDirective,
    FadeInImageDirective,
    VideoModalContainerComponent,
    GoogleSigninDirective,
    RequestComponent,
    EditorRequestComponent,
    TermsConditionsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    FormsModule,
    InViewDirective,
    ScrollToDirective,
    ProgressiveImageDirective,
    FadeInImageDirective,
    GoogleSigninDirective,
    VideoModalContainerComponent,
  ]
})
export class CoreModule { }
